<!--
# -----------------------------------------------------------------------------
# Component: PolicyMain.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Policy Header -> Main Tab
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex lg12 xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{ labels.mainTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="purple" v-on="on" @click="showPolicyTextDialog">
                    <v-icon dark>mdi-note-text</v-icon>
                  </v-btn>
                </template>
                <span>{{ labels.policyText }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="indigo" v-on="on" @click="doPolClauseList">
                    <v-icon dark>mdi-library-books</v-icon>
                  </v-btn>
                </template>
                <span>{{ labels.policyClause }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="pink" v-on="on" @click="doPolHdrStatsList">
                    <v-icon dark>mdi-chart-bar</v-icon>
                  </v-btn>
                </template>
                <span>{{ labels.policyStat }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.prevPolNo"
                      :label="labels.prevPolNo"
                      :error-messages="errors.collect('prevPolNo')"
                      data-vv-name="prevPolNo"
                      :data-vv-as="labels.prevPolNo"
                      v-validate="'max:16'"
                      @change="doPrevPolNo()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 xs12>
                    <v-autocomplete
                      :items="yesnoList"
                      :label="labels.moCmpUpld"
                      v-model="mainForm.moCmpUpld"
                      item-text="label"
                      item-value="value"
                      data-vv-name="moCmpUpld"
                      :data-vv-as="labels.moCmpUpld"
                      :error-messages="errors.collect('moCmpUpld')"
                      v-validate="valMoCmpUpld"
                      @change="doMoCmpUpld()"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg4 xs12>
                    <v-text-field
                      ref="moCmpNo"
                      v-model="mainForm.moCmpNo"
                      :label="labels.moCmpNo"
                      :error-messages="errors.collect('moCmpNo')"
                      data-vv-name="moCmpNo"
                      :data-vv-as="labels.moCmpNo"
                      v-validate="valMoCmpNo"
                      @blur="doMoCmpNo"
                      :disabled="mainForm.moCmpUpld"
                    >
                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                        <v-icon color="info" @click="showPolicyHelpList = true">mdi-magnify</v-icon>
                      </v-slide-x-reverse-transition>
                    </v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.ctyList"
                      v-model="mainForm.cty"
                      :label="labels.cty"
                      item-text="label"
                      item-value="value"
                      data-vv-name="cty"
                      :data-vv-as="labels.cty"
                      :error-messages="errors.collect('cty')"
                      v-validate="'required'"
                      :loading="fetchDataLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.polStatList"
                      v-model="mainForm.polStat"
                      :label="labels.polStat"
                      item-text="label"
                      item-value="value"
                      data-vv-name="polStat"
                      :data-vv-as="labels.polStat"
                      :error-messages="errors.collect('polStat')"
                      v-validate="'required'"
                      :disabled="disablePolStat"
                      @change="doPolStat()"
                      :loading="fetchDataLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg4 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.intermediaryList"
                      v-model="mainForm.acctNo1"
                      :label="labels.acctNo1"
                      item-text="label"
                      item-value="value"
                      data-vv-name="acctNo1"
                      :data-vv-as="labels.acctNo1"
                      :error-messages="errors.collect('acctNo1')"
                      v-validate="'required'"
                      :disabled="!disableRI"
                      :loading="fetchDataLoading"
                      @change="doAcctNo1(), changeInterScheme()"
                    ></v-autocomplete>
                    <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="doAcceptInter()"/>
                  </v-flex>
                  <v-flex lg2 xs12>
                    <v-text-field
                      v-model="mainForm.acctNoSfx"
                      :label="labels.acctNoSfx"
                      :error-messages="errors.collect('acctNoSfx')"
                      data-vv-name="acctNoSfx"
                      :data-vv-as="labels.acctNoSfx"
                      v-validate="'required|max:4'"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.currList"
                      v-model="mainForm.billCurr"
                      :label="labels.billCurr"
                      item-text="label"
                      item-value="value"
                      data-vv-name="billCurr"
                      :data-vv-as="labels.billCurr"
                      :error-messages="errors.collect('billCurr')"
                      v-validate="'required'"
                      @change="doCurrRate"
                      :loading="fetchDataLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg3 xs12>
                    <v-text-field
                      ref="billCurrRate"
                      v-model="mainForm.billCurrRate"
                      :label="labels.billCurrRate"
                      :error-messages="errors.collect('billCurrRate')"
                      data-vv-name="billCurrRate"
                      :data-vv-as="labels.billCurrRate"
                      v-num-mask="{ negative: false, intScale: 18, decScale: 7 }"
                      v-validate="'required|mask_decimal:7|mask_min_value:0.0000001|max:18'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.schemeList"
                      v-model="mainForm.scheme"
                      :label="labels.scheme"
                      item-text="label"
                      item-value="value"
                      data-vv-name="scheme"
                      :data-vv-as="labels.scheme"
                      :error-messages="errors.collect('scheme')"
                      :loading="schemeListLoading"
                      clearable
                      @change="doSchemeClause()"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.promotionList"
                      v-model="mainForm.promotion"
                      :label="labels.promotion"
                      item-text="label"
                      item-value="value"
                      data-vv-name="promotion"
                      :data-vv-as="labels.promotion"
                      :error-messages="errors.collect('promotion')"
                      :loading="fetchDataLoading"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.paytMethList"
                      v-model="mainForm.paytMeth"
                      :label="labels.paytMeth"
                      item-text="label"
                      item-value="value"
                      data-vv-name="paytMeth"
                      :data-vv-as="labels.paytMeth"
                      :error-messages="errors.collect('paytMeth')"
                      v-validate="'required'"
                      @input="doPaytMeth"
                      :loading="fetchDataLoading"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12 v-if="!disablePayDetails">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn fab small icon color="grey lighten-4" v-on="on" @click.native="doPayDetails">
                          <v-icon color="primary">mdi-cash</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ labels.payDetails }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex lg6 xs12 v-else></v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.interGrp12List"
                      v-model="mainForm.finInst"
                      :label="labels.finInst"
                      item-text="label"
                      item-value="value"
                      data-vv-name="finInst"
                      :data-vv-as="labels.finInst"
                      :error-messages="errors.collect('finInst')"
                      :loading="fetchDataLoading"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.cpArmList"
                      v-model="mainForm.cpCode"
                      :label="labels.cpCode"
                      item-text="label"
                      item-value="value"
                      data-vv-name="cpCode"
                      :data-vv-as="labels.cpCode"
                      :error-messages="errors.collect('cpCode')"
                      :loading="fetchDataLoading"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-checkbox v-model="mainForm.appShortTerm" :label="labels.appShortTerm"></v-checkbox>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-checkbox v-model="mainForm.appRiskTax" :label="labels.appRiskTax"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels>
            <v-expansion-panel v-if="!disabledPA">
              <v-expansion-panel-header>
                <div xs12>
                  <v-icon>mdi-account-box</v-icon><span class="headerTitle">{{ labels.paTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex lg6 xs12>
                        <v-autocomplete
                          :items="policyHeaderParam.paGrpPolList"
                          v-model="mainForm.paPolCoverType"
                          :label="labels.paPolCoverType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="paPolCoverType"
                          :data-vv-as="labels.paPolCoverType"
                          :error-messages="errors.collect('paPolCoverType')"
                          :loading="fetchDataLoading"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 xs12>
                        <v-autocomplete
                          :items="policyHeaderParam.paGrpNamedPolList"
                          v-model="mainForm.paGroupType"
                          :label="labels.paGroupType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="paGroupType"
                          :data-vv-as="labels.paGroupType"
                          :error-messages="errors.collect('paGroupType')"
                          :loading="fetchDataLoading"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="!disabledHE">
              <v-expansion-panel-header>
                <div xs12>
                  <v-icon>mdi-hospital</v-icon><span class="headerTitle">{{ labels.medicalTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.medGrpPolList"
                            v-model="mainForm.medPolCoverType"
                            :label="labels.medPolCoverType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="medPolCoverType"
                            :data-vv-as="labels.medPolCoverType"
                            :error-messages="errors.collect('medPolCoverType')"
                            :loading="fetchDataLoading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.medGrpNamedPolList"
                            v-model="mainForm.medGroupType"
                            :label="labels.medGroupType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="medGroupType"
                            :data-vv-as="labels.medGroupType"
                            :error-messages="errors.collect('medGroupType')"
                            :loading="fetchDataLoading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.medStdBenRateList"
                            v-model="mainForm.stdBenRate"
                            :label="labels.stdBenRate"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stdBenRate"
                            :data-vv-as="labels.stdBenRate"
                            :error-messages="errors.collect('stdBenRate')"
                            :loading="fetchDataLoading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <div class="body-2">{{ labels.insBasis }}</div>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.medEmpContList"
                            v-model="mainForm.empCont"
                            :label="labels.empCont"
                            item-text="label"
                            item-value="value"
                            data-vv-name="empCont"
                            :data-vv-as="labels.empCont"
                            :error-messages="errors.collect('empCont')"
                            :loading="fetchDataLoading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.medDepContList"
                            v-model="mainForm.depdCont"
                            :label="labels.depdCont"
                            item-text="label"
                            item-value="value"
                            data-vv-name="depdCont"
                            :data-vv-as="labels.depdCont"
                            :error-messages="errors.collect('depdCont')"
                            :loading="fetchDataLoading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <div border="1" class="body-2">{{ labels.shedType }}</div>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-checkbox v-model="mainForm.prtSchedInsd" :label="labels.prtSchedInsd"></v-checkbox>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-checkbox v-model="mainForm.prtSchedBen" :label="labels.prtSchedBen"></v-checkbox>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-checkbox v-model="mainForm.prtSchedPrem" :label="labels.prtSchedPrem"></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <div class="body-2">{{ labels.uploadBrdx }}</div>
                        </v-flex>
                        <v-flex lg8 xs12>
                          <v-btn color="primary" dark small>
                            <v-icon>mdi-folder</v-icon>
                            {{ labels.chooseFile }} </v-btn
                          >No File
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-btn color="primary" dark small> <v-icon>mdi-arrow-up</v-icon>{{ labels.upload }} </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="!polMaster.dri" :expand="disableRI" :disabled="disableRI">
              <v-expansion-panel-header>
                <div xs12>
                  <v-icon>mdi-repeat</v-icon><span class="headerTitle">{{ labels.riTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg8 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.cedantList"
                            v-model="mainForm.cedAnt"
                            :label="labels.cedAnt"
                            item-text="label"
                            item-value="value"
                            data-vv-name="cedAnt"
                            :data-vv-as="labels.cedAnt"
                            :error-messages="errors.collect('cedAnt')"
                            :disabled="disableRI"
                            clearable
                            @change="doCedAnt()"
                            :loading="fetchDataLoading"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-autocomplete
                            :items="policyHeaderParam.cedAcctNoSfxList"
                            v-model="mainForm.cedAcctNoSfx"
                            :label="labels.cedAcctNoSfx"
                            item-text="label"
                            item-value="value"
                            data-vv-name="cedAcctNoSfx"
                            :data-vv-as="labels.cedAcctNoSfx"
                            :error-messages="errors.collect('cedAcctNoSfx')"
                            :disabled="disableRI"
                            clearable
                            :loading="fetchDataLoading"
                            v-validate="'required'"
                            @change="doCedAcctNoSfx"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-text-field
                            ref="cedSI"
                            v-model="mainForm.cedSI"
                            :label="labels.cedSI"
                            :error-messages="errors.collect('cedSI')"
                            data-vv-name="cedSI"
                            :data-vv-as="labels.cedSI"
                            v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                            :disabled="disableRI"
                            @blur="doWarnCedSI"
                            v-validate="this.checkCedSIZero"
                          ></v-text-field>
                          <warning v-model="warnCedSI" @ok="doAcceptCedSI">{{ warnCedSIMsg }}</warning>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-text-field
                            ref="ourSharePct"
                            v-model="mainForm.ourSharePct"
                            :label="labels.ourSharePct"
                            :error-messages="errors.collect('ourSharePct')"
                            data-vv-name="ourSharePct"
                            :data-vv-as="labels.ourSharePct"
                            :max="'100'"
                            v-num-mask="{ negative: false, intScale: 3, decScale: 6 }"
                            :disabled="disableRI"
                            @blur="getOurShareSi"
                            v-validate="'required|mask_max_value:100'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-text-field ref="ourShareSi" v-model="mainForm.ourShareSi" :label="labels.ourShareSi" disabled></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-text-field
                            ref="cedPolNo"
                            v-model="mainForm.cedPolNo"
                            :label="labels.cedPolNo"
                            :error-messages="errors.collect('cedPolNo')"
                            data-vv-name="cedPolNo"
                            :data-vv-as="labels.cedPolNo"
                            v-validate="'max:20'"
                            :disabled="disableRI"
                            @blur="doWarnCedPolNo"
                          ></v-text-field>
                          <warning v-model="warnCedPolNo" @ok="doAcceptCedPolNo">{{ warnCedPolNoMsg }}</warning>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-text-field
                            ref="cedCesNo"
                            v-model="mainForm.cedCesNo"
                            :label="labels.cedCesNo"
                            :error-messages="errors.collect('cedCesNo')"
                            data-vv-name="cedCesNo"
                            :data-vv-as="labels.cedCesNo"
                            v-validate="'max:40'"
                            :disabled="disableRI"
                            @blur="doWarnCedCesNo"
                          ></v-text-field>
                          <warning v-model="warnCedCesNo" @ok="doAcceptCedCesNo">{{ warnCedCesNoMsg }}</warning>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-autocomplete
                            :items="yesnoconList"
                            :label="labels.recip"
                            v-model="mainForm.recip"
                            item-text="label"
                            item-value="value"
                            data-vv-name="recip"
                            :data-vv-as="labels.recip"
                            :error-messages="errors.collect('recip')"
                            v-validate="'required'"
                            :disabled="disableRecip"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-divider class="mt-3 mb-3"></v-divider>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="subheading">{{ labels.contractTitle }}</div>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex lg6 xs12>
                          <cal-picker
                            v-model="mainForm.ccaDate"
                            :label="labels.ccaDate"
                            data-vv-name="ccaDate"
                            :data-vv-as="labels.ccaDate"
                            :error-messages="errors.collect('ccaDate')"
                            :disabled="disableRI"
                            :loading="dateLoading"
                            v-validate="valContrctCertDatecca"
                          ></cal-picker>
                          <warning v-model="warnAcceptDatecca" @ok="doAcceptAcceptDatecca" @cancel="doCancelAcceptDatecca">{{
                            warnAcceptDateMsgcca
                          }}</warning>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <cal-picker
                            v-model="mainForm.ccdDate"
                            :label="labels.ccdDate"
                            data-vv-name="ccdDate"
                            :data-vv-as="labels.ccdDate"
                            :error-messages="errors.collect('ccdDate')"
                            :disabled="disableRI"
                            :loading="dateLoading"
                            v-validate="valContrctCertDateccd"
                          ></cal-picker>
                          <warning v-model="warnAcceptDateccd" @ok="doAcceptAcceptDateccd" @cancel="doCancelAcceptDateccd">{{
                            warnAcceptDateMsgccd
                          }}</warning>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex lg4 xs12>
                          <v-subheader class="queryLabel">{{ labels.ccDateEntUsrId }}</v-subheader>
                          <div class="queryValue">{{ ccDateEntUsrRefId }}</div>
                        </v-flex>
                        <v-flex lg4 xs12>
                          <v-subheader class="queryLabel">{{ labels.ccDateRevUsrId }}</v-subheader>
                          <div class="queryValue">{{ ccDateRevUsrRefId }}</div>
                        </v-flex>
                        <v-flex lg4> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="polMaster.appCoIns" :expand="!disableCoIns" :value="[true]">
              <v-expansion-panel-header>
                <div xs12>
                  <v-icon>mdi-account-multiple-outline</v-icon><span class="headerTitle">{{ labels.coinsTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-autocomplete
                            :items="ynList"
                            v-model="mainForm.billCoIns"
                            :label="labels.billCoIns"
                            item-text="label"
                            item-value="value"
                            data-vv-name="billCoIns"
                            :data-vv-as="labels.billCoIns"
                            :error-messages="errors.collect('billCoIns')"
                            :disabled="disableCoIns"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            ref="coInsPct"
                            v-model="mainForm.coInsPct"
                            :label="labels.coInsPct"
                            type="tel"
                            v-num-mask="{ negative: false, intScale: 12, decScale: 6 }"
                            :error-messages="errors.collect('coInsPct')"
                            data-vv-name="coInsPct"
                            :data-vv-as="labels.coInsPct"
                            v-validate="valCoInsPct"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn class="mr-2" color="error" dark :loading="policy.saving" @click.prevent="doExit">
            {{ labels.exit }}
            <v-icon dark right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn class="mr-2" color="info" dark :loading="policy.saving" @click.prevent="doSave">
            {{ labels.save }}
            <v-icon dark right>mdi-content-save</v-icon>
          </v-btn>
          <v-btn class="mr-2" color="primary" dark :loading="policy.saving" @click.prevent="doProceed">
            {{ labels.proceed }}
            <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <!--AR: 10-Mar Moving all dialog boxes at the bottom -->
      <v-dialog v-model="policyTextDialog" width="50%" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.policyText }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-tabs v-model="tabMenu" slider-color="teal" show-arrows="">
                    <v-tab ripple :key="1">{{ labels.polUppTxt }}</v-tab>
                    <v-tab ripple :key="2">{{ labels.polLwrTxt }}</v-tab>
                    <v-tab ripple :key="3">{{ labels.polMemo }}</v-tab>
                    <v-tab ripple :key="4" :disabled="disableEndorse">{{ labels.polEndtTxt }}</v-tab>
                    <v-tab ripple :key="5" :disabled="disableRenewal">{{ labels.polRenTxt }}</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabMenu">
                    <v-tab-item :key="1">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="mainForm.polUppTxt"
                                :error-messages="errors.collect('polUppTxt')"
                                data-vv-validate-on="change"
                                data-vv-name="polUppTxt"
                                :data-vv-as="labels.polUppTxt"
                                :rows="10"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="2">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="mainForm.polLwrTxt"
                                :error-messages="errors.collect('polLwrTxt')"
                                data-vv-validate-on="change"
                                data-vv-name="polLwrTxt"
                                :data-vv-as="labels.polLwrTxt"
                                :rows="10"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="3">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="mainForm.polMemo"
                                :error-messages="errors.collect('polMemo')"
                                data-vv-validate-on="change"
                                data-vv-name="polMemo"
                                :data-vv-as="labels.polMemo"
                                :rows="10"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="4">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="mainForm.polEndtTxt"
                                :error-messages="errors.collect('polEndtTxt')"
                                data-vv-validate-on="change"
                                data-vv-name="polEndtTxt"
                                :data-vv-as="labels.polEndtTxt"
                                :rows="10"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="5">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="mainForm.polRenTxt"
                                :error-messages="errors.collect('polRenTxt')"
                                data-vv-validate-on="change"
                                data-vv-name="polRenTxt"
                                :data-vv-as="labels.polRenTxt"
                                :rows="10"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click.native="policyTextDialog = false"><span class="btn-normal-error">Close</span></v-btn>
            <v-btn depressed @click.native="policyTextDialog = true" @click="doPolTxtSave"
              ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
            >
            <v-btn depressed @click.native="loadPreSetDialog = true" @click="doLoadPreset"
              ><span class="btn-normal-primary">{{ labels.preset }}</span></v-btn
            >
            <v-dialog v-model="loadPreSetDialog" width="70%" persistent>
              <v-card>
                <v-card-title>
                  <div class="toolbar-title-2">{{ labels.defineText }}</div>
                </v-card-title>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 xs12>
                        <v-autocomplete
                          :items="scnRefNoList"
                          v-model="scnRefNo"
                          :label="labels.scnRefNo"
                          item-text="label"
                          item-value="value"
                          data-vv-name="scnRefNo"
                          :data-vv-as="labels.scnRefNo"
                          :error-messages="errors.collect('scnRefNo')"
                          readonly
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 xs12> </v-flex>
                      <v-flex lg6 xs12>
                        <v-text-field v-model="polTypeDesc" :label="labels.polType" data-vv-name="polTypeDesc" readonly></v-text-field>
                      </v-flex>
                      <v-flex lg6 xs12> </v-flex>
                      <v-flex xs12 class="mt-2">
                        <template>
                          <v-data-table
                            :headers="defaultHeaders"
                            :items="defaulText"
                            v-model="defTextSelected"
                            :loading="polTxtLoading"
                            item-key="txtRef"
                            :options.sync="pagination"
                            show-select
                            class="elevation-1"
                          >
                          </v-data-table>
                        </template>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn depressed @click.native="loadPreSetDialog = false"><span class="btn-normal-error">Close</span></v-btn>
                  <v-btn depressed @click="doSelectDefText"
                    ><span class="btn-normal-primary">{{ labels.select }}</span></v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog ref="paymentDetails" v-model="mainForm.paymentDetailsDialog" width="50%" persistent :disabled="disablePayDetails">
        <v-card>
          <v-toolbar>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.payDetails }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-flex xs12 v-if="showCreditCardDet">
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="body-2">{{ labels.ccDetails }}</div>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker
                      v-model="crCdForm.effDate"
                      data-vv-scope="crCdForm"
                      :label="labels.effDate"
                      :data-vv-as="labels.effDate"
                      data-vv-name="effDate"
                      :error-messages="errors.collect('crCdForm.effDate')"
                      v-validate="valEffDate"
                      :loading="crCdLoading"
                    ></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12> </v-flex>
                  <v-flex lg10 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.bankAbbrevList"
                      v-model="crCdForm.crBank"
                      data-vv-scope="crCdForm"
                      :label="labels.crBank"
                      item-text="label"
                      item-value="value"
                      data-vv-name="crBank"
                      :data-vv-as="labels.crBank"
                      :error-messages="errors.collect('crCdForm.crBank')"
                      v-validate="'required'"
                      :loading="crCdLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg2 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="ccTypeList"
                      v-model="crCdForm.crCdType"
                      data-vv-scope="crCdForm"
                      :label="labels.crCdType"
                      item-text="label"
                      item-value="value"
                      data-vv-name="crCdType"
                      :data-vv-as="labels.crCdType"
                      :error-messages="errors.collect('crCdForm.crCdType')"
                      v-validate="'required'"
                      :loading="crCdLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      ref="crCdNo"
                      v-creditcard-mask
                      key="crCdNo"
                      :prepend-icon="ccIcon"
                      v-model="crCdNo"
                      data-vv-scope="crCdForm"
                      :label="labels.crCdNo"
                      :error-messages="errors.collect('crCdForm.crCdNo')"
                      data-vv-name="crCdNo"
                      :data-vv-as="labels.crCdNo"
                      v-validate="'required|credit_card'"
                      :loading="crCdLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 xs12>
                    <v-text-field
                      key="cdSecurNo"
                      v-int-mask="{ intScale: 5 }"
                      type="tel"
                      prepend-icon="mdi-textbox-password"
                      data-vv-scope="crCdForm"
                      v-model="crCdForm.cdSecurNo"
                      :label="labels.cdSecurNo"
                      :error-messages="errors.collect('crCdForm.cdSecurNo')"
                      data-vv-name="cdSecurNo"
                      :data-vv-as="labels.cdSecurNo"
                      v-validate="'required|max:5|numeric'"
                      :loading="crCdLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-creditcard-exp-mask
                      key="crCdExpDate"
                      prepend-icon="mdi-calendar"
                      persistent-hint
                      hint="MM-YYYY"
                      data-vv-scope="crCdForm"
                      v-model="crCdForm.crCdExpDate"
                      :label="labels.crCdExpDate"
                      :error-messages="errors.collect('crCdForm.crCdExpDate')"
                      data-vv-name="crCdExpDate"
                      :data-vv-as="labels.crCdExpDate"
                      v-validate="'required|credit_card_exp'"
                      :loading="crCdLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12> </v-flex>
                  <v-flex lg10 xs12>
                    <v-text-field
                      v-model="crCdForm.cdHolderName"
                      data-vv-scope="crCdForm"
                      :label="labels.cdHolderName"
                      :error-messages="errors.collect('crCdForm.cdHolderName')"
                      data-vv-name="cdHolderName"
                      :data-vv-as="labels.cdHolderName"
                      v-validate="'required'"
                      :loading="crCdLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 xs12></v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-flex>
          <v-flex xs12 v-if="showGIRODet">
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex lg10 xs12>
                    <div class="body-2">{{ labels.giroDetails }}</div>
                  </v-flex>
                  <v-flex lg2xs12> </v-flex>
                  <v-flex lg10 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.bankAbbrevList"
                      v-model="bankDrForm.drBank"
                      data-vv-scope="bankDrForm"
                      :label="labels.drBank"
                      item-text="label"
                      item-value="value"
                      data-vv-name="drBank"
                      :data-vv-as="labels.drBank"
                      :error-messages="errors.collect('bankDrForm.drBank')"
                      v-validate="'required'"
                      @change="doDrBank"
                      :loading="bankDrLoading"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg2 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="bankDrForm.acctNo"
                      data-vv-scope="bankDrForm"
                      :label="labels.acctNo"
                      :error-messages="errors.collect('bankDrForm.acctNo')"
                      data-vv-name="acctNo"
                      :data-vv-as="labels.acctNo"
                      v-validate="valAcctNoField"
                      @change="doAcctNo"
                      :loading="acctNoLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 xs12>
                    <v-text-field
                      v-model="bankDrForm.giroID"
                      data-vv-scope="bankDrForm"
                      :label="labels.giroID"
                      :error-messages="errors.collect('bankDrForm.giroID')"
                      data-vv-name="giroID"
                      :data-vv-as="labels.giroID"
                      :loading="bankDrLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 xs12> </v-flex>
                  <v-flex lg10 xs12>
                    <v-text-field
                      v-model="bankDrForm.acctHolderName"
                      data-vv-scope="bankDrForm"
                      :label="labels.acctHolderName"
                      :error-messages="errors.collect('bankDrForm.acctHolderName')"
                      data-vv-name="acctHolderName"
                      :data-vv-as="labels.acctHolderName"
                      :loading="bankDrLoading"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker
                      v-model="bankDrForm.submitDate"
                      data-vv-scope="bankDrForm"
                      :label="labels.submitDate"
                      :data-vv-as="labels.submitDate"
                      data-vv-name="submitDate"
                      :error-messages="errors.collect('bankDrForm.submitDate')"
                      :loading="bankDrLoading"
                    ></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12> </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="policyHeaderParam.giroStatList"
                      data-vv-scope="bankDrForm"
                      v-model="bankDrForm.giroStat"
                      :label="labels.giroStat"
                      item-text="label"
                      item-value="value"
                      data-vv-name="giroStat"
                      :data-vv-as="labels.giroStat"
                      :error-messages="errors.collect('bankDrForm.giroStat')"
                      :loading="giroStatLoading"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12> </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-flex>
          <v-flex xs12 v-if="showCreditCardDet == false && showGIRODet == false">
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex lg6 xs12>
                    <span class="queryValue">You don't have enough permission to view payment details.</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-flex>
          <v-flex xs12>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-flex xs12 v-if="showCreditCardDet == false && showGIRODet == false">
                <v-btn depressed @click.native="mainForm.paymentDetailsDialog = false"><span class="btn-normal-error">Close</span></v-btn>
              </v-flex>
              <v-flex xs12 v-else>
                <v-btn depressed @click.native="doClosePayMeth"><span class="btn-normal-error">Close</span></v-btn>
                <v-btn depressed @click.prevent="doResetPaytMeth"
                  ><span class="btn-normal-primary">{{ labels.reset }}</span></v-btn
                >
                <v-btn depressed @click.prevent="doSavePaytMeth"
                  ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
                >
              </v-flex>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-dialog>

      <v-dialog v-model="policyClauseDialog" width="70%" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.policyClause }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <template>
                    <v-data-table
                      v-model="polClse.selected"
                      :headers="polClse.headers"
                      :items="polClse.items"
                      :loading="polClse.loading"
                      :options.sync="polClse.pagination"
                      item-key="clauseNo"
                      class="elevation-1"
                      show-select
                    >
                    </v-data-table>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click.native="policyClauseDialog = false" @click.prevent="doResetPolClse"
              ><span class="btn-normal-error">Close</span></v-btn
            >
            <v-btn depressed @click.native="doPromptDelPolClause"
              ><span class="btn-normal-error">{{ labels.delete }}</span></v-btn
            >
            <v-btn depressed @click.prevent="doPolClauseSave"
              ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
            >
            <v-btn depressed @click.native="loadClausePreSetDialog = true"
              ><span class="btn-normal-primary">{{ labels.preset }}</span></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loadDelPolClseDialog" width="50%" persistent :disabled="doCheckDelPolClseItem()">
        <v-card>
          <v-card-title>
            <div class="toolbar-title-2">{{ labels.delPolClses }}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg10 xs12>
                  <div>{{ labels.delPolClseMsg }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="doPolClauseDelete"
              ><span class="btn-normal-error">{{ labels.yes }}</span></v-btn
            >
            <v-btn depressed @click.native="loadDelPolClseDialog = false" @click="doResetPolClseSeletedColumn"
              ><span class="btn-normal-primary">{{ labels.no }}</span></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loadClausePreSetDialog" width="70%" persistent>
        <v-card>
          <v-card-title>
            <div class="toolbar-title-2">{{ labels.defineClause }}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg4 xs6>
                  <v-autocomplete
                    :items="clauseRefNoList"
                    v-model="polClse.clauseRefNo"
                    :label="labels.clauseRefNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="clauseRefNo"
                    :data-vv-as="labels.clauseRefNo"
                    :error-messages="errors.collect('clauseRefNo')"
                    readonly
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs6> </v-flex>
                <v-flex lg4 xs6>
                  <v-text-field v-model="polTypeDesc" :label="labels.polType" data-vv-name="polTypeDesc" readonly></v-text-field>
                </v-flex>
                <v-flex lg4 xs6>
                  <v-text-field v-model="polClse.clauseNo" :label="labels.clauseNo" data-vv-name="clauseNo"></v-text-field>
                </v-flex>
                <v-flex lg6 xs6> </v-flex>
                <v-flex xs12 class="mt-2">
                  <template>
                    <v-data-table
                      v-model="clause.selected"
                      :headers="clause.headers"
                      :items="clause.displayItems"
                      item-key="clauseNo"
                      :options.sync="clause.pagination"
                      show-select
                      class="elevation-1"
                    >
                    </v-data-table>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click.native="loadClausePreSetDialog = false"><span class="btn-normal-error">Close</span></v-btn>
            <v-btn depressed @click.native="loadClausePreSetDialog = false" @click="doSelectClause"
              ><span class="btn-normal-primary">{{ labels.select }}</span></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Policy Stats -->
      <v-dialog v-model="policyStatDialog" width="60%" persistent>
        <v-card>
          <v-toolbar densecolor="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.policyStat }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <template>
                    <v-data-table
                      v-model="polHdrStats.selected"
                      :headers="polHdrStats.headers"
                      :items="polHdrStats.items"
                      item-key="statsType"
                      class="elevation-1"
                      :loading="polHdrStats.loading"
                      :options.sync="polHdrStats.pagination"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.statsType }}</td>
                          <td>{{ row.item.statsTypeDesc }}</td>
                          <td>{{ row.item.statsVal }}</td>
                          <td>
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="doShowStatValue(row.item)">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </td>
                          <td>{{ row.item.statsValDesc }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click.native="policyStatDialog = false"><span class="btn-normal-error">Close</span></v-btn>
            <v-btn depressed @click="doPolStatsSave"
              ><span class="btn-normal-primary">{{ labels.save }}</span></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="statsValDialog" width="60%" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ labels.statsHelpList }}
            <v-spacer></v-spacer>
            <v-btn text icon @click="statsValDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <template>
                    <v-data-table
                      v-model="statsVal.selected"
                      :headers="statsVal.headers"
                      :items="statsVal.items"
                      item-key="statsVal"
                      class="elevation-1"
                      :loading="statsVal.loading"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.statsVal }}</td>
                          <td>{{ row.item.statsValDesc }}</td>
                          <td style="text-align: center">
                            <v-btn icon color="primary" text type="submit" @click.prevent="doSelectedStatsValue(row.item)">
                              <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="policy.saving" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <span class="info-dialog-msg-header">Oops something went wrong...</span>
              <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- 2021-01-05 LYT OS-624 -->
    <v-dialog v-model="showPolicyHelpList" width="1280px" persistent>
      <open-cover-master-policy-help-list @close="showPolicyHelpList = false" @assign-policy="assignPolicy"></open-cover-master-policy-help-list>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime, formatDisplayDate2 } from '@/utils/date'
import { POLICY_HEADER_TAB, POLICY_MAIN, POLCRCD_LOAD_DATA, POLBANKDR_LOAD_DATA } from '@/store/types'
import { ccType } from '@/const/underwriting'
import isAfter from 'date-fns/isAfter'
import differenceInDays from 'date-fns/differenceInDays'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number'
import OpenCoverMasterPolicyHelpList from '@/components/core/common/dialog/OpenCoverMasterPolicyHelpList'
import clone from 'clone'
import { isEqual } from '@/utils/compare'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      labels: {
        mainTitle: 'Main Details',
        prevPolNo: 'Previous Policy No.',
        moCmpUpld: 'Yes/No',
        moCmpNo: 'Open Cover / Master Policy No.',
        cty: 'Country*',
        polStat: 'Policy Status*',
        acctNo1: 'Billing Account No.',
        acctNoSfx: 'Suffix',
        billCurr: 'Currency',
        billCurrRate: 'Rate',
        scheme: 'Scheme',
        promotion: 'Promotion',
        paytMeth: 'Payment Method',
        finInst: 'Finance Company',
        cpCode: 'Corporate Partner (ARM)',
        appShortTerm: 'Apply Short Term Rate',
        appRiskTax: 'Apply Risk Level Tax',
        riTitle: "Reinsurance - Cedant's Information",
        cedAnt: 'Cedant Ref No.',
        cedAcctNoSfx: 'Suffix',
        cedSI: 'Cedant SI',
        ourSharePct: 'Our Share %',
        ourShareSi: 'Our Share SI',
        cedPolNo: 'Policy No.',
        cedCesNo: 'Cession No.',
        recip: 'Reciprocal Business',
        contractTitle: 'Contract Certainty Dates',
        coinsTitle: 'Coinsurance',
        ccaDate: 'Acceptance Date',
        ccdDate: 'Documentation Date',
        billCoIns: 'Bills Coinsurer’s Share',
        coInsPct: 'Share %',
        paTitle: 'Personal Accident Settings',
        medicalTitle: 'Medical Policy Settings',
        paPolCoverType: 'Type of Policy Cover',
        paGroupType: 'Type of Group Policy',
        medPolCoverType: 'Type of Policy Cover',
        medGroupType: 'Type of Group Policy',
        stdBenRate: 'Apply Premium Base on',
        insBasis: 'Basis of Insurance:',
        empCont: 'Employees',
        depdCont: 'Dependants',
        shedType: 'Print Schedule(s) of:',
        prtSchedInsd: 'Insured',
        prtSchedBen: 'Benefits',
        prtSchedPrem: 'Premium Table',
        uploadBrdx: 'Upload Bordereaux',
        uploadBrdxFile: 'File',
        chooseFile: 'Choose File',
        upload: 'Upload',
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save',
        proceed: 'Proceed',
        preset: 'Load Preset',
        payDetails: 'Payment Details',
        effDate: 'Effective Date',
        ccDetails: 'Credit Card Details',
        crBank: 'Bank Name',
        crCdType: 'Card Type',
        crCdNo: 'Card No.',
        cdSecurNo: 'CVV',
        crCdExpDate: 'Expiry Date',
        expMth: 'Expiry Month',
        expYr: 'Expiry Year',
        cdHolderName: 'Card Holder Name',
        acctNo: 'Bank A/C No',
        giroID: 'GIRO ID',
        acctHolderName: 'Account Holder Name',
        submitDate: 'Submission Date',
        giroStat: 'GIRO Status',
        drBank: 'Bank Name',
        policyText: 'Policy Text',
        policyClause: 'Policy Clause',
        policyStat: 'Policy Statistics',
        polUppTxt: 'Upper Text',
        polLwrTxt: 'Lower Text',
        polMemo: 'Memo Text',
        polEndtTxt: 'Endorsement Text',
        polRenTxt: 'Renewal Text',
        polRenMsg: 'Renewal Message',
        scnRefNo: 'Screen Reference No',
        select: 'Select',
        delete: 'Delete',
        delPolClses: 'Delete Policy Clauses',
        delPolClseMsg: 'Confirm Delete Policy Clauses?',
        defineClause: 'Predefined Clause',
        clauseRefNo: 'Clause Ref No.',
        clauseNo: 'Clause No.',
        yes: 'Yes',
        no: 'No',
        statsHelpList: 'List of Statistic Values',
        ccDateEntUsrId: 'Entered User Id',
        ccDateRevUsrId: 'Reviewed User Id'
      },
      mainForm: {
        prevPolNo: undefined,
        moCmpUpld: undefined,
        moCmpNo: undefined,
        cty: undefined,
        polStat: undefined,
        acctNo1: undefined,
        acctNoSfx: undefined,
        billCurr: undefined,
        billCurrRate: undefined,
        scheme: undefined,
        promotion: undefined,
        paytMeth: undefined,
        finInst: undefined,
        cpCode: undefined,
        appShortTerm: false,
        appRiskTax: false,
        cedAnt: undefined,
        cedAcctNoSfx: undefined,
        cedSI: undefined,
        ourSharePct: undefined,
        ourShareSi: undefined,
        cedPolNo: undefined,
        cedCesNo: undefined,
        recip: undefined,
        billCoIns: undefined,
        coInsPct: undefined,
        paPolCoverType: undefined,
        paGroupType: undefined,
        medPolCoverType: undefined,
        medGroupType: undefined,
        stdBenRate: undefined,
        empCont: undefined,
        depdCont: undefined,
        prtSchedInsd: false,
        prtSchedBen: false,
        prtSchedPrem: false,
        uploadBrdxFile: undefined,
        paymentDetailsDialog: false,
        agent: undefined,
        polUppTxt: undefined,
        polLwrTxt: undefined,
        polMemo: undefined,
        polEndtTxt: undefined,
        polRenTxt: undefined,
        ccaDate: undefined,
        ccdDate: undefined,
        ccDateEntDate: null,
        ccDateEntUsrId: null,
        ccDateRevDate: null,
        ccDateRevUsrId: null,
        noDrCrPrt: null,
        noTaxInvPrt: null
      },
      crCdForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        effDate: undefined,
        expMth: undefined,
        expYr: undefined,
        crBank: undefined,
        crCdType: undefined,
        crCdNo: undefined,
        cdSecurNo: undefined,
        crCdExpDate: undefined,
        cdHolderName: undefined
      },
      bankDrForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        effDate: undefined,
        drBank: undefined,
        acctNo: undefined,
        acctHolderName: undefined,
        giroID: undefined,
        submitDate: undefined,
        giroStat: undefined
      },
      policyHeaderParam: {
        ctyList: [],
        polStatList: [],
        intermediaryList: [],
        schemeList: [],
        promotionList: [],
        paytMethList: [],
        finCoList: [],
        interGrp12List: [],
        cpArmList: [],
        paGrpPolList: [],
        paGrpNamedPolList: [],
        medGrpPolList: [],
        medGrpNamedPolList: [],
        medStdBenRateList: [],
        medEmpContList: [],
        medDepContList: [],
        cedantList: [],
        cedAcctNoSfxList: [],
        bankAbbrevList: [],
        giroStatList: [],
        currList: []
      },
      policy: {
        saving: false
      },
      ynList: [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' }
      ],
      yesnoList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      yesnoconList: [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' },
        { label: 'Consortium', value: 'C' }
      ],
      scnRefNoList: [
        { label: 'Upper Text', value: '01' },
        { label: 'Lower text', value: '05' },
        { label: 'Memo text', value: '02' },
        { label: 'Endorsement text', value: '04' },
        { label: 'Renewal text', value: '03' }
      ],
      valSchemeForAgent: false,
      disableRI: undefined,
      disableCoIns: undefined,
      disablePolStat: undefined,
      disablePayDetails: undefined,
      disabledPA: undefined,
      disabledHE: undefined,
      disableRecip: undefined,
      warnCedSI: false,
      acceptCedSI: false,
      checkCedSIZero: 'required|not_zero',
      warnCedSIMsg: '10063 – Zero Ceding Co. SI although Ceding Co. No. entered. (10063)',
      warnCedPolNo: false,
      acceptCedPolNo: false,
      warnCedPolNoMsg: undefined,
      warnCedCesNo: false,
      acceptCedCesNo: false,
      warnCedCesNoMsg: undefined,
      fetchDataLoading: false,
      schemeListLoading: false,
      showCreditCardDet: false,
      showGIRODet: false,
      crCdNo: undefined,
      crCdLoading: undefined,
      bankDrLoading: undefined,
      acctNoLoading: undefined,
      giroStatLoading: undefined,
      policyTextDialog: false,
      policyClauseDialog: false,
      policyStatDialog: false,
      disableEndorse: undefined,
      disableRenewal: undefined,
      tabMenu: undefined,
      loadPreSetDialog: false,
      scnRefNo: undefined,
      polTypeDesc: undefined,
      defTextSelected: [],
      defaulText: [],
      defaultHeaders: [
        { text: 'Text Ref No.', align: 'left', value: 'txtRef' },
        { text: 'Text Title', value: 'txtTitle' },
        { text: 'Default Text', value: 'defTxt' }
      ],
      loading: undefined,
      polTxtLoading: false,
      pagination: undefined,
      polClse: {
        selected: [],
        headers: [
          { text: 'Clauses', align: 'left', value: 'clauseNo' },
          { text: 'Clauses Title', value: 'clauseTitle' },
          { text: 'Clauses Text', value: 'clauseTxt' }
        ],
        items: [],
        pagination: {
          itemsPerPage: 5
        },
        clauseRefNo: undefined,
        clauseNo: undefined,
        loading: undefined
      },
      loadDelPolClseDialog: false,
      loadClausePreSetDialog: false,
      clauseRefNoList: [
        { label: 'Policy', value: '01' },
        { label: 'Risk', value: '02' },
        { label: 'Item', value: '03' },
        { label: 'Scheme', value: '04' }
      ],
      clause: {
        selected: [],
        headers: [
          { text: 'Clause No', align: 'left', value: 'clauseNo' },
          { text: 'Clause Title', value: 'clauseTitle' },
          { text: 'Clause Text', value: 'clauseTxt' },
          { text: 'Premium Warranty', value: 'premWar' }
        ],
        items: [],
        pagination: {
          itemsPerPage: 5
        },
        selectedClause: [],
        displayItems: []
      },
      polClseForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        tranType: undefined,
        clauses: []
      },
      polHdrStats: {
        selected: [],
        headers: [
          { text: 'Statistics Type', align: 'left', value: 'statsType' },
          { text: 'Description', value: 'statsTypeDesc' },
          { text: 'Statistics Value', value: 'statsVal' },
          { text: '', sortable: false, value: 'searchStatsValue' },
          { text: 'Description', value: 'statsValDesc' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        },
        loading: undefined
      },
      statsVal: {
        selected: [],
        headers: [
          { text: 'Statistics Value', align: 'left', value: 'statsVal' },
          { text: 'Description', value: 'statsValDesc' },
          { text: 'Action', align: 'center', sortable: false, value: '' }
        ],
        items: [],
        loading: undefined
      },
      statsValDialog: false,
      polHdrStatsForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        statsType: [],
        statsVal: []
      },
      warnAcceptDatecca: false,
      warnAcceptDateccd: false,
      acceptAcceptDatecca: false,
      acceptAcceptDateccd: false,
      warnAcceptDateMsgcca: undefined,
      warnAcceptDateMsgccd: undefined,
      dateLoading: false,
      usrRefId: undefined,
      ccDateEntUsrRefId: undefined,
      ccDateRevUsrRefId: undefined,
      tempCCType: undefined,
      error: {
        acctNo: undefined,
        moCmpNo: undefined
      },
      showErrorDialog: false,
      perOmn: false,
      showPolicyHelpList: false,
      polRenMsg: undefined
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    usrId() {
      return this.$store.state.token.usrId
    },
    valCoInsPct() {
      if (this.mainForm.billCoIns !== undefined && this.mainForm.billCoIns !== '' && parseInt(this.mainForm.coInsPct) === 0) {
        return 'valField:' + 'Mandatory when you are the lead coinsurer. (10021)'
      } else if ((this.mainForm.billCoIns === undefined || this.mainForm.billCoIns === '') && parseInt(this.mainForm.coInsPct) > 0) {
        return 'valField:' + 'Not permitted when you are not the lead coinsurer. (10022)'
      } else {
        return ''
      }
    },
    polCrCd() {
      return this.$store.state.underwriting.policy.polCrCd
    },
    polBankDr() {
      return this.$store.state.underwriting.policy.polBankDr
    },
    valEffDate() {
      return 'required|end_trandate:' + this.polMaster.tranDate
    },
    valContrctCertDatecca() {
      if (this.acceptAcceptDatecca) {
        return ''
      } else if (this.polMaster.comDate != null) {
        return 'valContrctCertDatecca:' + this.polMaster.comDate
      } else if (this.polMaster.tranDate != null) {
        return 'valContrctCertDatecca:' + this.polMaster.tranDate
      } else {
        return 'valContrctCertDatecca:' + undefined
      }
    },
    valContrctCertDateccd() {
      if (this.acceptAcceptDateccd) {
        return ''
      } else if (this.polMaster.comDate != null) {
        return 'valContrctCertDateccd:' + this.polMaster.comDate
      } else if (this.polMaster.tranDate != null) {
        return 'valContrctCertDateccd:' + this.polMaster.tranDate
      } else {
        return 'valContrctCertDateccd:' + undefined
      }
    },
    getPaytMeth() {
      return this.policyHeaderParam.paytMethList.filter(paytMeth => {
        return paytMeth.value === this.mainForm.paytMeth
      })
    },
    ccTypeList() {
      let result = []
      Object.keys(ccType).forEach(function(key) {
        const status = ccType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    getCurr() {
      return this.policyHeaderParam.currList.filter(curr => {
        return curr.value === this.mainForm.billCurr
      })
    },
    initPolicyHeader() {
      return this.$store.state.underwriting.policyHeaderSettings.init
    },
    ccIcon() {
      if (this.tempCCType) {
        if (this.tempCCType === 'visa') {
          return 'fab fa-cc-visa'
        } else if (this.tempCCType === 'mastercard') {
          return 'fab fa-cc-mastercard'
        } else if (this.tempCCType === 'diners') {
          return 'fab fa-cc-diners-club'
        } else if (this.tempCCType === 'amex') {
          return 'fab fa-cc-amex'
        } else if (this.tempCCType === 'jcb') {
          return 'fab fa-cc-jcb'
        } else if (this.tempCCType === 'discover') {
          return 'fab fa-cc-discover'
        } else {
          return 'mdi-credit-card'
        }
      } else {
        return 'mdi-credit-card'
      }
    },
    valAcctNoField() {
      if (this.error.acctNo === undefined) {
        return 'required|max:20'
      } else {
        return 'required|max:20|valField:' + this.error.acctNo
      }
    },
    getGiroStat() {
      return this.policyHeaderParam.giroStatList.filter(giroStat => {
        return giroStat.value === this.bankDrForm.giroStat
      })
    },
    // 2021-01-05 LYT OS-624
    valMoCmpUpld() {
      if (this.mainForm.moCmpUpld === true && this.perOmn === 'N') {
        return 'required|valField:' + 'Selected Policy Type not allow Open Cover/Master Policy. (100020)'
      } else {
        return 'required'
      }
    },
    valMoCmpNo() {
      if (this.error.moCmpNo === undefined) {
        return 'entry|max:16'
      } else {
        return 'entry|max:16|valField:' + this.error.moCmpNo
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'mainForm.cedAcedAnt': function(value) {
      if (this.disableRI !== true) {
        if (this.mainForm.cedAnt !== '' && this.mainForm.cedAnt !== undefined) {
          this.disableRecip = true
        } else {
          this.disableRecip = false
        }
      } else {
        this.disableRecip = true
      }
    },
    crCdNo: {
      handler: function(value) {
        if (this.$refs.crCdNo) {
          this.tempCCType = this.$refs.crCdNo.$el.cleave.properties.creditCardType
        }
      }
    },
    'polClse.clauseNo': function(value) {
      if (value) {
        this.clause.displayItems = this.clause.items.filter((item) => item.clauseNo.toLowerCase().includes(value.toLowerCase()))
      } else {
        this.clause.displayItems = this.clause.items
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getDataList('ctyList')
      // AR: Added to resolve invalid URL issues 7-Jun-2020
      await Promise.all([this.$store.dispatch('policyHeaderInit')])
      if (this.initPolicyHeader === 1) {
        this.loadInit()
      }
    },
    async loadInit() {
      // this.getRenMsg()
      this.mainForm.prevPolNo = this.polMaster.prevPolNo
      this.mainForm.moCmpUpld = this.polMaster.moCmpUpld
      this.mainForm.moCmpNo = this.polMaster.moCmpNo
      this.mainForm.cty = this.polMaster.cty
      this.mainForm.polStat = this.polMaster.polStat
      this.mainForm.acctNo1 = this.polMaster.acctNo1
      this.mainForm.acctNoSfx = this.polMaster.acctNoSfx
      this.mainForm.billCurr = this.polMaster.billCurr
      this.mainForm.billCurrRate = formatDisplayNumber(this.polMaster.billCurrRate, 7)
      this.mainForm.scheme = this.polMaster.scheme
      this.mainForm.promotion = this.polMaster.promotion
      this.mainForm.paytMeth = this.polMaster.paytMeth
      this.mainForm.finInst = this.polMaster.finInst
      this.mainForm.cpCode = this.polMaster.cpCode
      this.mainForm.appShortTerm = this.polMaster.appShortTerm
      this.mainForm.appRiskTax = this.polMaster.appRiskTax
      this.mainForm.cedAnt = this.polMaster.cedAnt
      this.mainForm.cedAcctNoSfx = this.polMaster.cedAcctNoSfx
      this.mainForm.cedSI = formatPrice(this.polMaster.cedSI)
      this.mainForm.ourSharePct = formatDisplayNumber(this.polMaster.ourSharePct, 6)
      // 2020-12-22 LYT OS-612
      // this.mainForm.ourShareSi = formatPrice(this.polMaster.ourShareSi)
      this.getOurShareSi()
      this.mainForm.cedPolNo = this.polMaster.cedPolNo
      this.mainForm.cedCesNo = this.polMaster.cedCesNo
      this.mainForm.recip = this.polMaster.recip
      this.mainForm.ccaDate = this.polMaster.ccaDate
      this.mainForm.ccdDate = this.polMaster.ccdDate
      this.mainForm.billCoIns = this.polMaster.billCoIns
      this.mainForm.coInsPct = formatDisplayNumber(this.polMaster.coInsPct, 6)
      this.mainForm.stdBenRate = this.polMaster.stdBenRate
      this.mainForm.empCont = this.polMaster.empCont
      this.mainForm.depdCont = this.polMaster.depdCont
      this.mainForm.prtSchedInsd = this.polMaster.prtSchedInsd
      this.mainForm.prtSchedBen = this.polMaster.prtSchedBen
      this.mainForm.prtSchedPrem = this.polMaster.prtSchedPrem
      this.mainForm.polUppTxt = this.polMaster.polUppTxt
      this.mainForm.polLwrTxt = this.polMaster.polLwrTxt
      this.mainForm.polMemo = this.polMaster.polMemo
      this.mainForm.polEndtTxt = this.polMaster.polEndtTxt
      this.mainForm.polRenTxt = this.polMaster.polRenTxt
      this.mainForm.agent = this.polMaster.agent
      this.mainForm.ccDateEntDate = this.polMaster.ccDateEntDate
      this.mainForm.ccDateEntUsrId = this.polMaster.ccDateEntUsrId
      this.mainForm.ccDateRevDate = this.polMaster.ccDateRevDate
      this.mainForm.ccDateRevUsrId = this.polMaster.ccDateRevUsrId
      this.polTypeDesc = this.policyInfo.polTypeDesc
      this.polMaster.dri = this.polMaster.dri === 'false' ? false : Boolean(this.polMaster.dri)
      this.disableRI = this.polMaster.dri
      this.disableRecip = this.disableRI

      if (this.$refs.billCurrRate) {
        // this.$refs.billCurrRate.$el.cleave.setRawValue(this.mainForm.billCurrRate)
      }

      if (this.disableRI) {
        this.getDataList('intermediaryList')
      }

      if (this.polMaster.appCoIns) {
        this.disableCoIns = false
      } else {
        this.disableCoIns = true
      }

      if (this.mainForm.polStat === undefined || this.mainForm.polStat === '') {
        this.mainForm.polStat = 'IF'
        this.mainForm.moCmpUpld = false
        this.mainForm.recip = 'N'
      }

      // 2020-10-21 LYT OS-521
      if (this.polMaster.tranType === 'E' || this.polMaster.tranType === 'C') {
        this.disableEndorse = false
      } else {
        this.disableEndorse = true
      }

      if (this.polMaster.tranType === 'R') {
        this.disableRenewal = false
      } else {
        this.disableRenewal = true
      }

      this.polClse.clauseRefNo = '01'
      this.copymainForm = clone(this.mainForm)
      await this.checkPerAuto()
      this.doPolStat()
      this.fetchData()
      this.getCurrencyList()
      this.getValSchemeForAgent()
      this.getPolType()
      this.getPolTextList()
      this.getClauseList()
      this.getUserRefId()
      this.createStats()
    },
    async changeInterScheme() {
      if (this.mainForm.acctNo1 && this.valSchemeForAgent === true) {
        this.getValSchemeForAgent()
      }
    },
    async getValSchemeForAgent() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getValScheme
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          this.valSchemeForAgent = data
          if (data === true) {
            this.getSchemeInter()
          } else {
            this.getSchemeList()
          }
        } catch (err) {
          this.loading = false
        }
      }
    },
    async getDataList(listName, paramString) {
      const apiUrl = this.$store.state.commons.menu.commonDataListDropDown
      if (apiUrl) {
        const params = {
          listName: listName,
          paramString: paramString
        }
        const result = await this.$http.get(expandURI(apiUrl, params))
        if (result.data.dataList) {
          this.$set(this.policyHeaderParam, listName, result.data.dataList)
        }
      }
    },
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.menu.policyHeader
      if (apiUrl) {
        this.fetchDataLoading = true
        const result = await this.$http.get(apiUrl)
        // AR: Commented due to loading issue, moved to getDataList() method - 31Oct2020
        // if (result.data.countryList) {
        //   this.$set(this.policyHeaderParam, 'ctyList', result.data.countryList)
        // }
        if (result.data.polStatusList) {
          if (this.disablePolStat === true) {
            this.$set(this.policyHeaderParam, 'polStatList', result.data.polStatusList)
          } else {
            this.$set(this.policyHeaderParam, 'polStatList', result.data.polStatsList)
          }
        }
        // AR: Commented due to loading issue, moved to getDataList() method - 31Oct2020
        // if (result.data.intermediaryList) {
        //   this.$set(this.policyHeaderParam, 'intermediaryList', result.data.intermediaryList)
        // }
        if (result.data.promotionList) {
          this.$set(this.policyHeaderParam, 'promotionList', result.data.promotionList)
        }
        if (result.data.paytMethList) {
          this.$set(this.policyHeaderParam, 'paytMethList', result.data.paytMethList)
          this.doPaytMeth()
        }
        if (result.data.interGrp12List) {
          this.$set(this.policyHeaderParam, 'interGrp12List', result.data.interGrp12List)
        }
        if (result.data.cpArmList) {
          this.$set(this.policyHeaderParam, 'cpArmList', result.data.cpArmList)
        }
        if (result.data.paGrpPolList) {
          this.$set(this.policyHeaderParam, 'paGrpPolList', result.data.paGrpPolList)
        }
        if (result.data.paGrpNamedPolList) {
          this.$set(this.policyHeaderParam, 'paGrpNamedPolList', result.data.paGrpNamedPolList)
        }
        if (result.data.medGrpPolList) {
          this.$set(this.policyHeaderParam, 'medGrpPolList', result.data.medGrpPolList)
        }
        if (result.data.medGrpNamedPolList) {
          this.$set(this.policyHeaderParam, 'medGrpNamedPolList', result.data.medGrpNamedPolList)
        }
        if (result.data.medStdBenRateList) {
          this.$set(this.policyHeaderParam, 'medStdBenRateList', result.data.medStdBenRateList)
        }
        if (result.data.medEmpContList) {
          this.$set(this.policyHeaderParam, 'medEmpContList', result.data.medEmpContList)
        }
        if (result.data.medDepContList) {
          this.$set(this.policyHeaderParam, 'medDepContList', result.data.medDepContList)
        }
        if (result.data.cedantList) {
          this.$set(this.policyHeaderParam, 'cedantList', result.data.cedantList)
          if (!this.disableRI) {
            this.$set(this.policyHeaderParam, 'intermediaryList', result.data.cedantList)
            // OS-612 Issue 04-Jan-2021
            this.doCedAnt()
          }
        }
        if (result.data.cedAcctNoSfxList) {
          this.$set(this.policyHeaderParam, 'cedAcctNoSfxList', result.data.cedAcctNoSfxList)
        }
        if (result.data.bankAbbrevList) {
          this.$set(this.policyHeaderParam, 'bankAbbrevList', result.data.bankAbbrevList)
        }
        this.fetchDataLoading = false
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [fetchData]')
      }
    },
    async getCurrencyList() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.currencyList
      if (apiUrl) {
        try {
          const tempEffDate = formatDisplayDate(this.polMaster.tranDate)
          const expand = {
            effDate: tempEffDate
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            if (data.data) {
              this.$set(this.policyHeaderParam, 'currList', data.data)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getCurrencyList]')
      }
    },
    async getSchemeList() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.schemeList
      if (apiUrl) {
        try {
          this.schemeListLoading = true
          const expand = {
            polType: this.polMaster.polType,
            effDate: undefined
          }
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            expand.effDate = formatDisplayDate(this.polMaster.comDate)
          } else if (this.polMaster.endtDate !== undefined && this.polMaster.endtDate !== null) {
            expand.effDate = formatDisplayDate(this.polMaster.endtDate)
          } else {
            expand.effDate = formatDisplayDate(this.polMaster.tranDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            if (data.data) {
              this.$set(this.policyHeaderParam, 'schemeList', data.data)
            }
          }
          this.schemeListLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeListLoading = false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getSchemeList]')
      }
    },
    doPrevPolNo() {
      if (this.mainForm.prevPolNo !== '') {
        this.getPrevPolNo()
      }
    },
    async getPrevPolNo() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.prvPolNo
      if (apiUrl) {
        try {
          const expand = {
            prvPolNo: this.mainForm.prevPolNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            this.message(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPrevPolNo]')
      }
    },
    doPolStat() {
      if (this.mainForm.polStat !== '' && !this.disablePolStat) {
        this.getPolStat()
      }
    },
    async checkPerAuto() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.checkPerAuto
      if (apiUrl) {
        try {
          const expand = {
            polStatus: this.mainForm.polStat
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.disablePolStat = data
          }
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async getPolStat() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.polStatus
      if (apiUrl) {
        try {
          const expand = {
            polStatus: this.mainForm.polStat
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            if (data.perAuto) {
              //   this.disablePolStat = true
              // } else {
              //   this.disablePolStat = false
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolStat]')
      }
    },
    doCurrRate() {
      if (this.getCurr.length > 0) {
        this.mainForm.billCurrRate = this.getCurr[0].secondaryValue.toFixed(7)
      }
    },
    async getCurrRate() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.currRate
      if (apiUrl) {
        try {
          const tempEffDate = formatDisplayDate(this.polMaster.tranDate)
          const expand = {
            curr: this.mainForm.billCurr,
            effDate: tempEffDate
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            this.mainForm.billCurrRate = data.data.toFixed(7)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.mainForm.billCurrRate = '0.0000000'
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getCurrRate]')
      }
    },
    async doPaytMeth() {
      if (this.getPaytMeth !== undefined) {
        if (this.getPaytMeth.length > 0) {
          if (this.getPaytMeth[0].secondaryValue === 'NA') {
            this.showGIRODet = false
            this.showCreditCardDet = false
            this.disablePayDetails = true
          } else if (this.getPaytMeth[0].secondaryValue) {
            // CARD
            this.showCreditCardDet = true
            this.showGIRODet = false
            this.disablePayDetails = false
          } else if (this.getPaytMeth[0].thirdValue) {
            // GIRO
            this.showGIRODet = true
            this.showCreditCardDet = false
            this.disablePayDetails = false
          } else {
            this.showGIRODet = false
            this.showCreditCardDet = false
            this.disablePayDetails = true
          }
        }
      }
    },
    async getPolType() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.polType
      if (apiUrl) {
        try {
          const expand = {
            polType: this.polMaster.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result

            if (data.polTypeAppId === 'PA') {
              this.disabledPA = false
              this.mainForm.paPolCoverType = this.polMaster.grpPol
              this.mainForm.paGroupType = this.polMaster.grpNamedPol
            } else {
              this.disabledPA = true
              this.mainForm.paPolCoverType = undefined
              this.mainForm.paGroupType = undefined
            }
            if (data.polTypeAppId === 'HE') {
              this.disabledHE = false
              this.polMaster.medPolCoverType = this.polMaster.grpPol
              this.polMaster.medGroupType = this.polMaster.grpNamedPol
            } else {
              this.disabledHE = true
              this.polMaster.medPolCoverType = undefined
              this.polMaster.medGroupType = undefined
            }
            // 2021-01-05 OS-624
            this.perOmn = data.perOmn
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          // this.busClsLoading = false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolType]')
      }
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    doReset() {
      this.doInit()
    },
    doSave(value) {
      this.resetMessages()
      this.doValidateAllWarn().then(result2 => {
        if (result2) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.policy.saving = true
              this.doPolMasterSave().then(success => {
                if (success) {
                  this.$toast.success('Policy Master has been Saved')
                } else {
                  this.$toast.error('Policy Master Save Failed')
                }
                this.policy.saving = false
              })
            } else {
              this.promptFieldCheck()
              // return false
            }
          })
        }
      })
    },
    async savePolMaster() {
      let result = false
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          result = true
        } else {
          this.copymainForm = clone(this.mainForm)
          this.$store.commit(POLICY_MAIN, this.mainForm)
          const saveResult = await this.$store.dispatch('savePolMasterMain')
          result = saveResult
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
        result = false
      }
      return result
    },
    async doPolMasterSave(skipValInter) {
      let result = false
      if (skipValInter === true) {
        await this.savePolMaster().then(success => {
          result = success
        })
      } else {
        await this.validateIntermediary(this.polMaster.tranDate, this.mainForm.acctNo1).then(async() => {
          if (this.promptMsg === false || this.acceptInterWarn === true) {
            await this.savePolMaster().then(success => {
              result = success
            })
          } else {
            this.policy.saving = false
          }
        })
      }
      return result
    },
    doProceed() {
      this.resetMessages()
      this.doValidateAllWarn().then(result2 => {
        if (result2) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.policy.saving = true
              // this.$store.dispatch('policyMain', this.mainForm)
              this.valPolStatsVal().then(successVal => {
                if (successVal) {
                  this.doPolMasterSave().then(success => {
                    if (success) {
                      this.$store.commit(POLICY_HEADER_TAB, 1)
                      // this.$emit('setHeader', '1')
                      this.$router.push({ name: 'policyInsured' })
                    } else {
                      this.policy.saving = false
                    }
                  })
                } else {
                  this.policy.saving = false
                }
              })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      })
    },
    doWarnCedSI() {
      // 2020-12-22 LYT OS-612
      if (this.$refs.cedSI) {
        this.$refs.cedSI.$el.cleave.setRawValue(this.mainForm.cedSI)
      }
      if (this.acceptCedSI !== true && (this.mainForm.cedSI === undefined || parseInt(this.mainForm.cedSI) === 0)) {
        this.warnCedSI = true
        // this.$refs.cedSI.focus()
        return false
      } else {
        this.getOurShareSi()
      }
      return true
    },
    doAcceptInter() {
      this.acceptInterWarn = true
      this.policy.save = false
    },
    doAcceptCedSI() {
      this.acceptCedSI = true
      this.checkCedSIZero = 'required'
    },
    doWarnCedPolNo() {
      if (
        this.acceptCedPolNo !== true &&
        (this.mainForm.cedAnt === undefined || this.mainForm.cedAnt === '') &&
        this.mainForm.cedPolNo !== undefined &&
        this.mainForm.cedPolNo !== ''
      ) {
        this.warnCedPolNoMsg = '10065 – Ceding Company cannot be blank when &1 entered. (10065)'
        this.warnCedPolNoMsg = this.warnCedPolNoMsg.replace('&1', this.mainForm.cedPolNo)
        this.warnCedPolNo = true
        this.$refs.cedPolNo.focus()
        return false
      }
      return true
    },
    doAcceptCedCesNo() {
      this.acceptCedCesNo = true
    },
    doWarnCedCesNo() {
      if (
        this.acceptCedCesNo !== true &&
        (this.mainForm.cedAnt === undefined || this.mainForm.cedAnt === '') &&
        this.mainForm.cedCesNo !== undefined &&
        this.mainForm.cedCesNo !== ''
      ) {
        this.warnCedCesNoMsg = 'Ceding Company cannot be blank when &1 entered. (10065)'
        this.warnCedCesNoMsg = this.warnCedCesNoMsg.replace('&1', this.mainForm.cedCesNo)
        this.warnCedCesNo = true
        this.$refs.cedCesNo.focus()
        return false
      }
      return true
    },
    doAcceptCedPolNo() {
      this.acceptCedPolNo = true
    },
    // async doValidateAllWarn() {
    //   return true
    // },
    doPayDetails() {
      this.mainForm.paymentDetailsDialog = true
      if (this.showCreditCardDet) {
        if (this.polCrCd.polNo === undefined) {
          this.getPolCrCd().then(result => {
            this.setCrCdForm()
          })
        } else {
          this.setCrCdForm()
        }
      } else if (this.showGIRODet) {
        if (this.polBankDr.polNo === undefined) {
          this.getPolBankDr().then(result => {
            this.setBankDrForm()
          })
        } else {
          this.setBankDrForm()
        }
      }
    },
    setCrCdForm() {
      if (this.polCrCd.polNo === undefined) {
        this.crCdForm.polNo = this.polMaster.polNo
        this.crCdForm.renCnt = this.polMaster.renCnt
        this.crCdForm.endtCnt = this.polMaster.endtCnt
      } else {
        this.crCdForm.polNo = this.polCrCd.polNo
        this.crCdForm.renCnt = this.polCrCd.renCnt
        this.crCdForm.endtCnt = this.polCrCd.endtCnt
      }
      this.crCdForm.effDate = this.polCrCd.effDate
      this.crCdForm.crBank = this.polCrCd.crBank
      this.crCdForm.crCdType = this.polCrCd.crCdType
      this.crCdForm.crCdNo = this.polCrCd.crCdNo
      this.crCdNo = this.polCrCd.crCdNo
      if (this.crCdNo.length === 16) {
        const tempCrCdNo = this.crCdNo
        this.crCdNo = tempCrCdNo.substr(0, 4) + ' ' + tempCrCdNo.substr(4, 4) + ' ' + tempCrCdNo.substr(8, 4) + ' ' + tempCrCdNo.substr(12, 4)
      }
      this.crCdForm.cdSecurNo = this.polCrCd.cdSecurNo
      this.crCdForm.crCdExpDate = this.formatExpDate(this.polCrCd.expMth, this.polCrCd.expYr)
      this.crCdForm.cdHolderName = this.polCrCd.cdHolderName
    },
    setBankDrForm() {
      if (this.polBankDr.polNo === undefined) {
        this.bankDrForm.polNo = this.polMaster.polNo
        this.bankDrForm.renCnt = this.polMaster.renCnt
        this.bankDrForm.endtCnt = this.polMaster.endtCnt
        this.bankDrForm.effDate = this.polMaster.tranDate
      } else {
        this.bankDrForm.polNo = this.polBankDr.polNo
        this.bankDrForm.renCnt = this.polBankDr.renCnt
        this.bankDrForm.endtCnt = this.polBankDr.endtCnt
        this.bankDrForm.effDate = this.polBankDr.effDate
      }
      this.bankDrForm.drBank = this.polBankDr.drBank
      this.bankDrForm.acctNo = this.polBankDr.acctNo
      this.bankDrForm.acctHolderName = this.polBankDr.acctHolderName
      this.bankDrForm.giroID = this.polBankDr.giNo
      this.bankDrForm.submitDate = this.polBankDr.submitDate
      this.bankDrForm.giroStat = this.polBankDr.giStat
      this.doDrBank()
    },
    async getPolCrCd() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getPolCrCd
      if (apiUrl) {
        try {
          this.crCdLoading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            const { data } = result
            this.$store.commit(POLCRCD_LOAD_DATA, data)
            this.crCdLoading = false
            return true
          } else {
            this.crCdLoading = false
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.crCdLoading = false
          return false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolCrCd]')
        return false
      }
    },
    async getPolBankDr() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getPolBankDr
      if (apiUrl) {
        try {
          this.bankDrLoading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            const { data } = result
            this.$store.commit(POLBANKDR_LOAD_DATA, data)
            this.bankDrLoading = false
            return true
          } else {
            this.bankDrLoading = false
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.bankDrLoading = false
          return false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolBankDr]')
        return false
      }
    },
    doClosePayMeth() {
      this.mainForm.paymentDetailsDialog = false
    },
    doResetPaytMeth() {
      this.doPayDetails()
    },
    doSavePaytMeth() {
      this.resetMessages()
      if (this.showCreditCardDet) {
        this.$validator.validateAll('crCdForm').then(result => {
          if (result) {
            this.policy.saving = true

            // UnMask
            this.$refs.crCdNo.$el.cleave.setRawValue(this.crCdNo)
            this.crCdForm.crCdNo = this.$refs.crCdNo.$el.cleave.getRawValue()

            if (this.crCdForm.crCdExpDate) {
              this.crCdForm.expMth = null
              this.crCdForm.expYr = null
              const splitArr = this.crCdForm.crCdExpDate.split('-')
              if (splitArr && splitArr.length === 2) {
                if (splitArr[0].length === 2 && splitArr[1].length === 4) {
                  this.crCdForm.expMth = Number(splitArr[0])
                  this.crCdForm.expYr = Number(splitArr[1])
                }
              }
            }

            this.$store.dispatch('savePolCrCd', this.crCdForm).then(success => {
              if (success) {
                this.$toast.success('Payment Details has been Saved')
              } else {
                this.$toast.error('Payment Details Save Failed')
              }
              this.policy.saving = false
            })
          } else {
            this.promptFieldCheck()
          }
        })
      } else if (this.showGIRODet) {
        this.$validator.validateAll('bankDrForm').then(result => {
          if (result) {
            this.policy.saving = true
            this.$store.dispatch('savePolBankDr', this.bankDrForm).then(success => {
              if (success) {
                this.$toast.success('Payment Details has been Saved')
              } else {
                this.$toast.error('Payment Details Save Failed')
              }
              this.policy.saving = false
            })
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    formatExpDate(mth, yr) {
      if (mth && yr) {
        if (mth < 10) {
          mth = '0' + mth
        }
        return mth + '-' + yr
      } else {
        return ''
      }
    },
    doPolTxtSave() {
      this.policy.saving = true
      this.doPolMasterSave(true).then(success => {
        if (success) {
          this.$toast.success('Policy Text has been Saved')
        } else {
          this.$toast.error('Policy Text Save Failed')
        }
        this.policy.saving = false
      })
    },
    doLoadPreset() {
      this.defTextSelected = []
      if (this.tabMenu === 0) {
        this.scnRefNo = '01'
        this.defTextSelected = this.selectedPolUpperTxt
        this.defaulText = this.itemsPolUpperTxt
      } else if (this.tabMenu === 1) {
        this.scnRefNo = '05'
        this.defTextSelected = this.selectedPolLowerTxt
        this.defaulText = this.itemsPolLowerTxt
      } else if (this.tabMenu === 2) {
        this.scnRefNo = '02'
        this.defTextSelected = this.selectedPolMemoTxt
        this.defaulText = this.itemsPolMemoTxt
      } else if (this.tabMenu === 3) {
        this.scnRefNo = '04'
        this.defTextSelected = this.selectedPolEndorseTxt
        this.defaulText = this.itemsPolEndorseTxt
      } else if (this.tabMenu === 4) {
        this.scnRefNo = '03'
        this.defTextSelected = this.selectedPolRenewalTxt
        this.defaulText = this.itemsPolRenewalTxt
      }
    },
    async getPolTextList() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getPolTextList
      if (apiUrl) {
        try {
          this.polTxtLoading = true
          const expand = {
            polType: this.polMaster.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polUpperTxtList) {
            const { data } = result.data.polUpperTxtList
            if (data) {
              this.itemsPolUpperTxt = []
              this.selectedPolUpperTxt = []
              data.map(upperText => {
                const upperTextList = {
                  txtRef: upperText.txtRef,
                  txtTitle: upperText.txtTitle,
                  defTxt: upperText.defTxt
                }
                this.itemsPolUpperTxt.push(upperTextList)
                if (upperText.txtDef === true) {
                  this.selectedPolUpperTxt.push(upperTextList)
                }
              })
            } else {
              this.itemsPolUpperTxt = []
            }
          }

          if (result.data.polLowerTxtList) {
            const { data } = result.data.polLowerTxtList
            if (data) {
              this.itemsPolLowerTxt = []
              this.selectedPolLowerTxt = []
              data.map(lowerText => {
                const lowerTextList = {
                  txtRef: lowerText.txtRef,
                  txtTitle: lowerText.txtTitle,
                  defTxt: lowerText.defTxt
                }
                this.itemsPolLowerTxt.push(lowerTextList)
                if (lowerText.txtDef === true) {
                  this.selectedPolLowerTxt.push(lowerTextList)
                }
              })
            } else {
              this.itemsPolLowerTxt = []
            }
          }

          if (result.data.polMemoTxtList) {
            const { data } = result.data.polMemoTxtList
            if (data) {
              this.itemsPolMemoTxt = []
              this.selectedPolMemoTxt = []
              data.map(memoText => {
                const memoTextList = {
                  txtRef: memoText.txtRef,
                  txtTitle: memoText.txtTitle,
                  defTxt: memoText.defTxt
                }
                this.itemsPolMemoTxt.push(memoTextList)
                if (memoText.txtDef === true) {
                  this.selectedPolMemoTxt.push(memoTextList)
                }
              })
            } else {
              this.itemsPolMemoTxt = []
            }
          }

          if (result.data.polEndorseTxtList) {
            const { data } = result.data.polEndorseTxtList
            if (data) {
              this.itemsPolEndorseTxt = []
              this.selectedPolEndorseTxt = []
              data.map(endorseText => {
                const endorseTextList = {
                  txtRef: endorseText.txtRef,
                  txtTitle: endorseText.txtTitle,
                  defTxt: endorseText.defTxt
                }
                this.itemsPolEndorseTxt.push(endorseTextList)
                if (endorseText.txtDef === true) {
                  this.selectedPolEndorseTxt.push(endorseTextList)
                }
              })
            } else {
              this.itemsPolEndorseTxt = []
            }
          }

          if (result.data.polRenewalTxtList) {
            const { data } = result.data.polRenewalTxtList
            if (data) {
              this.itemsPolRenewalTxt = []
              this.selectedPolRenewalTxt = []
              data.map(renewalText => {
                const renewalTextList = {
                  txtRef: renewalText.txtRef,
                  txtTitle: renewalText.txtTitle,
                  defTxt: renewalText.defTxt
                }
                this.itemsPolRenewalTxt.push(renewalTextList)
                if (renewalText.txtDef === true) {
                  this.selectedPolRenewalTxt.push(renewalTextList)
                }
              })
            } else {
              this.itemsPolRenewalTxt = []
            }
          }

          this.polTxtLoading = false
        } catch (err) {
          this.polTxtLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolTextList]')
      }
    },
    doSelectDefText() {
      if (this.tabMenu === 0) {
        if (this.mainForm.polUppTxt.length > 0 && this.mainForm.polUppTxt.charAt(this.mainForm.polUppTxt.length - 1) !== '\n') {
          this.mainForm.polUppTxt = this.mainForm.polUppTxt + '\n'
        }
        for (var a = 0; a < this.defTextSelected.length; a++) {
          this.mainForm.polUppTxt = this.mainForm.polUppTxt + this.defTextSelected[a].defTxt + '\n'
        }
      }
      if (this.tabMenu === 1) {
        if (this.mainForm.polLwrTxt.length > 0 && this.mainForm.polLwrTxt.charAt(this.mainForm.polLwrTxt.length - 1) !== '\n') {
          this.mainForm.polLwrTxt = this.mainForm.polLwrTxt + '\n'
        }
        for (var b = 0; b < this.defTextSelected.length; b++) {
          this.mainForm.polLwrTxt = this.mainForm.polLwrTxt + this.defTextSelected[b].defTxt + '\n'
        }
      }
      if (this.tabMenu === 2) {
        if (this.mainForm.polMemo.length > 0 && this.mainForm.polMemo.charAt(this.mainForm.polMemo.length - 1) !== '\n') {
          this.mainForm.polMemo = this.mainForm.polMemo + '\n'
        }
        for (var c = 0; c < this.defTextSelected.length; c++) {
          this.mainForm.polMemo = this.mainForm.polMemo + this.defTextSelected[c].defTxt + '\n'
        }
      }
      if (this.tabMenu === 3) {
        if (this.mainForm.polEndtTxt.length > 0 && this.mainForm.polEndtTxt.charAt(this.mainForm.polEndtTxt.length - 1) !== '\n') {
          this.mainForm.polEndtTxt = this.mainForm.polEndtTxt + '\n'
        }
        for (var d = 0; d < this.defTextSelected.length; d++) {
          this.mainForm.polEndtTxt = this.mainForm.polEndtTxt + this.defTextSelected[d].defTxt + '\n'
        }
      }
      if (this.tabMenu === 4) {
        if (this.mainForm.polRenTxt.length > 0 && this.mainForm.polRenTxt.charAt(this.mainForm.polRenTxt.length - 1) !== '\n') {
          this.mainForm.polRenTxt = this.mainForm.polRenTxt + '\n'
        }
        for (var e = 0; e < this.defTextSelected.length; e++) {
          this.mainForm.polRenTxt = this.mainForm.polRenTxt + this.defTextSelected[e].defTxt + '\n'
        }
      }
      this.loadPreSetDialog = false
    },
    doResetPolClseSeletedColumn() {
      this.polClse.selected = []
    },
    doResetPolClse() {
      this.polClse.selected = []
      this.polClse.items = []
      this.polClse.displayItems = []
    },
    async doPolClauseSave() {
      this.polClseForm.polNo = this.polMaster.polNo
      this.polClseForm.renCnt = this.polMaster.renCnt
      this.polClseForm.endtCnt = this.polMaster.endtCnt
      this.polClseForm.tranType = this.polMaster.tranType
      this.polClseForm.clauses = []
      for (var i = 0; i < this.polClse.items.length; i++) {
        this.polClseForm.clauses.push(this.polClse.items[i].clauseNo)
      }
      try {
        this.policy.saving = true
        const saveResult = await this.$store.dispatch('savePolClse', this.polClseForm)
        if (saveResult) {
          this.$toast.success('Policy Clause has been Saved')
          this.policy.saving = false
        } else {
          this.$toast.error('Policy Clause Save Failed')
          this.policy.saving = false
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    doCheckDelPolClseItem() {
      return this.polClse.selected.length > 0
    },
    doPolClauseDelete() {
      for (var i = 0; i < this.polClse.selected.length; i++) {
        for (var ii = 0; ii < this.polClse.items.length; ii++) {
          if (this.polClse.selected[i].clauseNo === this.polClse.items[ii].clauseNo) {
            this.$delete(this.polClse.items, ii)
          }
        }
      }
      this.clause.selected = this.polClse.items
      this.loadDelPolClseDialog = false
    },
    doSelectClause() {
      this.clause.selected.map(select => {
        const clauseList = {
          clauseNo: select.clauseNo,
          clauseTitle: select.clauseTitle,
          clauseTxt: select.clauseTxt,
          clausePremWar: select.clausePremWar
        }
        this.clause.selectedClause.push(clauseList)
      })
      if (this.clause.selectedClause.length > 0 && this.polClse.items.length > 0) {
        for (var i = 0; i < this.clause.selectedClause.length; i++) {
          for (var ii = 0; ii < this.polClse.items.length; ii++) {
            if (this.clause.selectedClause[i].clauseNo === this.polClse.items[ii].clauseNo) {
              this.$delete(this.clause.selectedClause, i)
            }
          }
        }
      }
      if (this.clause.selectedClause.length > 0) {
        for (var iii = 0; iii < this.clause.selectedClause.length; iii++) {
          this.polClse.items.push(this.clause.selectedClause[iii])
        }
      }
      this.clause.selectedClause = []
    },
    doPolClauseList() {
      this.policyClauseDialog = true
      this.getPolClauseList()
    },
    async getClauseList() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.clauseList
      if (apiUrl) {
        const expand = {
          polType: this.polMaster.polType
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        const { data } = result
        if (data) {
          data.data.map(clause => {
            const clauseList = {
              clauseNo: clause.clseNo,
              clauseTitle: clause.clseTitle,
              clauseTxt: clause.clseTxt,
              clausePremWar: clause.isPremWar
            }
            this.clause.items.push(clauseList)
            this.clause.displayItems.push(clauseList)
            if (clause.defClse === true) {
              this.clause.selected.push(clauseList)
            }
          })
        } else {
          this.clause.items = []
          this.clause.displayItems = []
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getClauseList]')
      }
    },
    async getPolClauseList() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.polClauseList
      if (apiUrl) {
        try {
          this.polClse.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            tranType: this.polMaster.tranType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.polClse.items = []
            data.data.map(clause => {
              const clauseList = {
                clauseNo: clause.clseNo,
                clauseTitle: clause.clseTitle,
                clauseTxt: clause.clseTxt
              }
              this.polClse.items.push(clauseList)
            })
            this.polClse.loading = false
          } else {
            this.polClse.items = []
            this.polClse.loading = false
          }
          if (this.polClse.items.length > 0) {
            this.clause.selected = this.polClse.items
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getPolClauseList]')
      }
    },
    async doPolHdrStatsList() {
      this.policyStatDialog = true
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.polHdrStatsList
      if (apiUrl) {
        try {
          this.polHdrStats.items = []
          this.polHdrStats.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            data.data.map(statistic => {
              const statisticList = {
                statsType: statistic.statsType,
                statsTypeDesc: statistic.statsTypeDesc,
                statsVal: statistic.statsValue,
                statsValDesc: statistic.statsValueDesc
              }
              this.polHdrStats.items.push(statisticList)
            })
            this.polHdrStats.loading = false
          } else {
            this.polHdrStats.items = []
            this.polHdrStats.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [doPolHdrStatsList]')
      }
    },
    doShowStatValue(data) {
      this.getStatsValue(data.statsType)
      this.statsValDialog = true
    },
    async doPolStatsSave() {
      this.polHdrStatsForm.polNo = this.polMaster.polNo
      this.polHdrStatsForm.renCnt = this.polMaster.renCnt
      this.polHdrStatsForm.endtCnt = this.polMaster.endtCnt
      this.polHdrStatsForm.statsType = []
      this.polHdrStatsForm.statsVal = []
      for (var i = 0; i < this.polHdrStats.items.length; i++) {
        this.polHdrStatsForm.statsType.push(this.polHdrStats.items[i].statsType)
        this.polHdrStatsForm.statsVal.push(this.polHdrStats.items[i].statsVal)
      }
      try {
        this.policy.saving = true
        const saveResult = await this.$store.dispatch('savePolHdrStats', this.polHdrStatsForm)
        if (saveResult) {
          const valStatus = await this.valPolStatsVal()
          if (valStatus) {
            this.$toast.success('Policy Statistics has been Saved')
            this.policy.saving = false
            // this.policyStatDialog = false
          } else {
            this.policy.saving = false
          }
        } else {
          this.$toast.error('Policy Statistics Save Failed')
          this.policy.saving = false
        }
      } catch (err) {
        this.policy.saving = false
        const { data } = err.response
        if (data) {
          this.message(data)
        }
      }
    },
    doSelectedStatsValue(data) {
      for (var i = 0; i < this.polHdrStats.items.length; i++) {
        if (this.polHdrStats.items[i].statsType === data.statsType) {
          this.polHdrStats.items[i].statsVal = data.statsVal
          this.polHdrStats.items[i].statsValDesc = data.statsValDesc
        }
      }
      this.statsValDialog = false
    },
    async getStatsValue(statsType) {
      this.statsVal.items = []
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.statsValList
      if (apiUrl) {
        try {
          this.statsVal.loading = true
          const expand = {
            statsType: statsType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            data.data.map(statsValue => {
              const statsValueList = {
                statsVal: statsValue.statsVal,
                statsValDesc: statsValue.statsValDesc,
                statsType: statsType
              }
              this.statsVal.items.push(statsValueList)
            })
            this.statsVal.loading = false
          } else {
            this.statsVal.items = []
            this.statsVal.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getStatsValue]')
      }
    },
    getOurShareSi() {
      // 2020-12-22 LYT OS-612
      if (this.$refs.ourSharePct) {
        this.$refs.ourSharePct.$el.cleave.setRawValue(this.mainForm.ourSharePct)
      }
      var cedSI = this.mainForm.cedSI
      var ourSharePct = this.mainForm.ourSharePct
      if (removeFormatNumber(cedSI) > 0 && removeFormatNumber(ourSharePct) > 0) {
        this.mainForm.ourShareSi = formatPrice((removeFormatNumber(cedSI) * removeFormatNumber(ourSharePct)) / 100)
      }
    },
    // async getRenMsg() {
    //   let cPolNo = ''
    //   cPolNo = this.polMaster.renCnt > 0 && this.polMaster.tranRel === false ? this.polMaster.prevPolNo : this.polMaster.polNo
    //   const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getPolRenMsg
    //   if (apiUrl) {
    //     try {
    //       const expand = {
    //         polNo: cPolNo
    //       }
    //       const result = await this.$http.get(expandURI(apiUrl, expand))
    //       const { data } = result.data
    //       if (data) {
    //         this.polRenMsg = data.renMsg.renMsg
    //       }
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.notify(data)
    //       }
    //     }
    //   }
    // },
    async doAcctNo1() {
      const acctNo1 = this.mainForm.acctNo1
      let item = this.policyHeaderParam.intermediaryList.filter(function(d) {
        return d.value === acctNo1
      })
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.interAbbrevName
      if (apiUrl) {
        try {
          const expand = {
            inter: item[0].value,
            interGrp: item[0].secondaryValue
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.mainForm.agent = data.interAbbrevName !== null ? data.interAbbrevName : ''
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [doAcctNo1]')
      }
      //
      this.getNoOfDrCrAndTaxInvPrt()
    },
    async getNoOfDrCrAndTaxInvPrt() {
      const acctNo1 = this.mainForm.acctNo1
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getNoOfDrCrAndTaxInvPrt
      if (apiUrl) {
        try {
          const expand = {
            inter: acctNo1
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.mainForm.noDrCrPrt = data.noDrCrPrt
          this.mainForm.noTaxInvPrt = data.noTaxInvPrt
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [doAcctNo1]')
      }
    },
    async doCedAnt() {
      const cedAnt = this.mainForm.cedAnt
      let item = this.policyHeaderParam.cedantList.filter(function(d) {
        return d.value === cedAnt
      })
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.interAbbrevName
      if (apiUrl) {
        try {
          const expand = {
            inter: item[0].value,
            interGrp: item[0].secondaryValue
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data.interAbbrevName !== null || data.interAbbrevName !== '') {
            this.mainForm.recip = 'Y'
            this.mainForm.acctNo1 = this.mainForm.cedAnt
            this.mainForm.agent = this.mainForm.cedAnt
            if (this.mainForm.cedAcctNoSfx === null || this.mainForm.cedAcctNoSfx === undefined || this.mainForm.cedAcctNoSfx === '') {
              this.getDefAcctNoSfx()
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [doCedAnt]')
      }
    },
    async getDefAcctNoSfx() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.defAcctNoSfx
      if (apiUrl) {
        const result = await this.$http.get(expandURI(apiUrl))
        const { data } = result.data
        if (data) {
          this.mainForm.cedAcctNoSfx = data.defAcctNoSfx
          this.doCedAcctNoSfx()
        }
      } else {
        this.$toast.error('getDefAcctNoSfx() The request failed because it is trying to execute an invalid API url. [getDefAcctNoSfx]')
      }
    },
    doCedAcctNoSfx() {
      this.mainForm.acctNoSfx = this.mainForm.cedAcctNoSfx
    },
    async getSchemeInter() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getValInterScheme
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            inter: this.mainForm.acctNo1,
            effDate: undefined
          }
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            expand.effDate = formatDisplayDate(this.polMaster.comDate)
          } else if (this.polMaster.endtDate !== undefined && this.polMaster.endtDate !== null) {
            expand.effDate = formatDisplayDate(this.polMaster.endtDate)
          } else {
            expand.effDate = formatDisplayDate(this.polMaster.tranDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            if (data.data) {
              this.$set(this.policyHeaderParam, 'schemeList', data.data)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getSchemeInter]')
      }
    },
    doAcceptAcceptDatecca() {
      this.acceptAcceptDatecca = true
      this.updateCcDate()
    },
    doCancelAcceptDatecca() {
      return this.mainForm.ccaDate
    },
    doAcceptAcceptDateccd() {
      this.acceptAcceptDateccd = true
      this.updateCcDate()
    },
    doCancelAcceptDateccd() {
      return this.mainForm.ccdDate
    },
    async doSchemeClause() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getDefSchemeClause
      if (apiUrl) {
        try {
          // this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            scheme: this.mainForm.scheme
          }
          await this.$http.get(expandURI(apiUrl, expand))
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [getSchemeInter]')
      }
    },
    updateCcDate() {
      if (this.mainForm.ccDateEntDate === undefined || this.mainForm.ccDateEntDate === null || this.mainForm.ccDateEntDate === '') {
        this.mainForm.ccDateEntDate = new Date()
        this.mainForm.ccDateEntUsrId = this.usrId
        this.ccDateEntUsrRefId = this.usrRefId
      }
      this.mainForm.ccDateRevDate = new Date()
      this.mainForm.ccDateRevUsrId = this.usrId
      this.ccDateRevUsrRefId = this.usrRefId
    },
    async getUserRefId() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.getUserRefId
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            this.usrRefId = result.data.usrRefId
            this.ccDateEntUsrRefId = result.data.ccDateEntUsrRefId
            this.ccDateRevUsrRefId = result.data.ccDateRevUsrRefId
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.initLoading = false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAcctNo() {
      if (this.bankDrForm.acctNo !== undefined) {
        const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.valAcctNo
        if (apiUrl) {
          this.acctNoLoading = true
          try {
            const expand = {
              acctNo: this.bankDrForm.acctNo
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.acctNo = undefined
            }
            this.acctNoLoading = false
          } catch (err) {
            this.acctNoLoading = false
            const { data } = err.response
            if (data) {
              this.error.acctNo = data.messages[0].message
            }
          }
        } else {
          // this.$toast.error('The request failed because it is trying to execute an invalid API url. [valAcctNo]')
        }
      }
    },
    async doDrBank() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.giroStatList
      if (apiUrl) {
        this.giroStatLoading = true
        try {
          const expand = {
            bankRef: this.bankDrForm.drBank,
            paytMeth: this.mainForm.paytMeth
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            if (data.data) {
              this.$set(this.policyHeaderParam, 'giroStatList', data.data)

              if (this.getGiroStat.length === 0) {
                this.bankDrForm.giroStat = ''
              }
            }
          }
          this.giroStatLoading = false
        } catch (err) {
          this.giroStatLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [giroStatList]')
      }
    },
    async valPolStatsVal() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.valPolStatsVal
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          await this.$http.get(expandURI(apiUrl, expand))
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url. [valPolStatsVal]')
      }
    },
    async showPolicyTextDialog() {
      this.policyTextDialog = true
      this.mainForm.polUppTxt = this.polMaster.polUppTxt
      this.mainForm.polLwrTxt = this.polMaster.polLwrTxt
      this.mainForm.polMemo = this.polMaster.polMemo
      this.mainForm.polEndtTxt = this.polMaster.polEndtTxt
      this.mainForm.polRenTxt = this.polMaster.polRenTxt
    },
    async doValidateAllWarn() {
      if ((!this.warnAcceptDatecca || (this.warnAcceptDatecca && this.acceptAcceptDatecca)) === false) {
        return false
      }

      if ((!this.warnAcceptDateccd || (this.warnAcceptDateccd && this.acceptAcceptDateccd)) === false) {
        return false
      }

      if (!this.disableRI && !this.acceptCedSI) {
        if (!this.doWarnCedSI()) {
          return false
        }
      }

      if (!this.disableRI && !this.acceptCedPolNo) {
        if (!this.doWarnCedPolNo()) {
          return false
        }
      }

      if (!this.disableRI && !this.acceptCedCesNo) {
        if (!this.doWarnCedCesNo()) {
          return false
        }
      }

      return true
    },
    doPromptDelPolClause() {
      // 2020-11-26 LYT SR5661
      let clauseNo = ''
      for (var i = 0; i < this.polClse.selected.length; i++) {
        if (clauseNo !== '') {
          clauseNo = clauseNo + ','
        }
        clauseNo = clauseNo + this.polClse.selected[i].clauseNo
      }
      this.labels.delPolClseMsg = 'Confirm Delete Policy Clauses? ' + clauseNo
      this.loadDelPolClseDialog = true
    },
    // 2021-01-05 LYT OS-624
    assignPolicy(moCmpNo) {
      this.mainForm.moCmpNo = moCmpNo
      this.showPolicyHelpList = false
      this.$refs.moCmpNo.focus()
      this.doMoCmpNo()
    },
    doMoCmpUpld() {
      if (this.mainForm.moCmpUpld === true) {
        this.mainForm.moCmpNo = ''
      }
    },
    async doMoCmpNo() {
      if (this.mainForm.moCmpNo !== undefined && this.mainForm.moCmpNo !== '') {
        const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.valMoCmpNo
        if (apiUrl) {
          // this.acctNoLoading = true
          try {
            const expand = {
              moCmpNo: this.mainForm.moCmpNo,
              comDate: formatDisplayDate2(this.polMaster.comDate)
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.moCmpNo = undefined
            }
            // this.acctNoLoading = false
          } catch (err) {
            // this.acctNoLoading = false
            const { data } = err.response
            if (data) {
              this.error.moCmpNo = data.messages[0].message
            }
          }
        } else {
          // this.$toast.error('The request failed because it is trying to execute an invalid API url. [valAcctNo]')
        }
      }
    },
    async createStats() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.createStats
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          this.$http.get(expandURI(apiUrl, expand))
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.initLoading = false
        }
      } else {
        // this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  // beforeMount() {
  //   this.doInit()
  // },
  mounted() {
    this.doInit()
  },
  created() {
    // Local validator
    const valTranDate = {
      getMessage: (field, args) => {
        return 'The ' + field + ' cannot be later than Policy Transaction Date. (10114)'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var endDate = args[0]
          if (endDate) {
            return !isAfter(removeTime(value), removeTime(endDate))
          } else {
            return true
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('end_trandate', valTranDate)

    const valContrctCertDatecca = {
      getMessage: (field, args) => {
        return '10435 – ' + field + ' is 100 days earlier or later than Commencement/Transaction date.(10435)'
      },
      validate: (value, args) => {
        if (value) {
          var pCTDate = args[0]
          let noDays = Math.abs(differenceInDays(removeTime(pCTDate), removeTime(value))) + 1
          // if (differenceInDays(removeTime(pCTDate), removeTime(value)) > 100) {
          if (noDays > 100) {
            if (!this.acceptAcceptDatecca && this.mainForm.ccaDate !== null && this.mainForm.ccaDate !== '') {
              this.warnAcceptDateMsgcca = '10435 – Acceptance date is 100 days earlier or later than Commencement/Transaction date.(10435)'
              this.warnAcceptDatecca = true
            }
            return false
          } else {
            this.updateCcDate()
            return true
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('valContrctCertDatecca', valContrctCertDatecca)

    const valContrctCertDateccd = {
      getMessage: (field, args) => {
        return '10435 – ' + field + ' is 100 days earlier or later than Commencement/Transaction date.(10435)'
      },
      validate: (value, args) => {
        if (value) {
          var pCTDate = args[0]
          let noDays = Math.abs(differenceInDays(removeTime(pCTDate), removeTime(value))) + 1
          // if (differenceInDays(removeTime(pCTDate), removeTime(value)) > 100) {
          if (noDays > 100) {
            if (!this.acceptAcceptDateccd && this.mainForm.ccdDate !== null && this.mainForm.ccdDate !== '') {
              this.warnAcceptDateMsgccd = '10435 – Documentation date is 100 days earlier or later than Commencement/Transaction date.(10435)'
              this.warnAcceptDateccd = true
            }
            return false
          } else {
            this.updateCcDate()
            return true
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('valContrctCertDateccd', valContrctCertDateccd)

    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    OpenCoverMasterPolicyHelpList
  }
}
</script>
